import { useEffect, useState } from 'react';
import { setClientFilters } from '../api/uat';

// Which optional step filters a client's testers are offered in the UAT module. Staff always see
// all of them. The default is none: "Ready to retest" and "Changed" are Mount Insights' own view of
// a round, and a tester works from Not run, Failed and Passed. This only picks buttons; it never
// changes a step's status.

export const OPTIONAL_FILTERS: { key: string; label: string; hint: string }[] = [
  { key: 'ready_to_retest', label: 'Ready to retest', hint: 'Steps whose issue has been fixed and is waiting for the tester to try again.' },
  { key: 'changed', label: 'Changed', hint: 'Steps edited after a tester last ran them.' },
];

type Act = (label: string, fn: () => Promise<unknown>) => Promise<void>;

export default function TesterFilters({ clientId, current, getToken, act }: {
  clientId: string; current: string[]; getToken: () => Promise<string | null>; act: Act;
}) {
  const [picked, setPicked] = useState<string[]>(current);
  useEffect(() => { setPicked(current); }, [current.join(',')]); // eslint-disable-line react-hooks/exhaustive-deps
  const dirty = [...picked].sort().join(',') !== [...current].sort().join(',');
  const toggle = (k: string) => setPicked((p) => (p.includes(k) ? p.filter((x) => x !== k) : [...p, k]));

  return (
    <section style={{ display: 'grid', gap: 8, background: 'var(--mi-surface)', border: '1px solid var(--mi-border)', borderRadius: 8, padding: 16 }} aria-label="Filters testers see">
      <h3 style={{ margin: 0, fontSize: 15 }}>Filters testers see</h3>
      <p style={{ margin: 0, fontSize: 13, color: 'var(--mi-muted)' }}>
        Testers always get All, Not run, Failed and Passed. Tick an extra filter to show it to this client’s testers too. Mount Insights staff always see every filter.
      </p>
      {OPTIONAL_FILTERS.map((f) => (
        <label key={f.key} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 13 }}>
          <input type="checkbox" checked={picked.includes(f.key)} onChange={() => toggle(f.key)} />
          <span><b>{f.label}</b> <span style={{ color: 'var(--mi-muted)' }}>{f.hint}</span></span>
        </label>
      ))}
      <div>
        <button className="btn-primary" disabled={!dirty}
          onClick={() => act('Tester filters saved.', async () => setClientFilters(clientId, picked, await getToken()))}>
          Save filters
        </button>
      </div>
    </section>
  );
}
